import { CheckBox, CheckBoxOutlineBlank, LockOpen, SaveAlt } from '@mui/icons-material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Avatar,
  Box,
  Button,
  Card,
  Drawer,
  Grid,
  LinearProgress,
  Menu,
  MenuItem,
  Modal,
  Skeleton,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import Documentation from 'src/components/document-management/documentation';
import MiscellaneousDocuments from 'src/components/document-management/miscellaneous-document';
import useCheckRole from 'src/hooks/use-check-role';
import useCurrentUser from 'src/hooks/use-current-user';
import { BasicDateRangeCalendar } from 'src/layouts/components/CustomDatePicker';
import { paths, permissions } from 'src/paths';
import { getSinglePatient } from 'src/redux/actions/patientAction';
import {
  closeEpisodeOfCare,
  getSingleEpisodeOfCare,
  resetCloseEpisodeOfCare,
  resetEditEpisodeOfCare,
} from 'src/redux/actions/patientEpisodeOfCare';
import { getScreening } from 'src/redux/actions/patientScreening';
import { isTherapyPlanningPatient } from 'src/redux/actions/therapyPlanning';
import { resetUpdateTherapistUnlock } from 'src/redux/actions/unlockTherapistAction';
import { convertDateToSelectedTimeZone } from 'src/utils/convertDateToSelectedTimeZone';
import discardIcon from '../../icons/untitled-ui/duocolor/discardIcon.svg';
import {
  ArrowIcon,
  CalenderIcon,
  CrossIcon,
  DownloadIconColor,
  EOCOpenIcon,
  PrintIcon,
} from '../therapist-dashboard/dashboard-icon';
import { CloseEOCCalender } from './CloseEOCCalender';
import EocDetailsDrawer from './EocDetailsDrawer';
import { ScreeningsTable } from './screening-table';
import SimpleSnackbar from './sub-components/snackBar';
import UnlockTherapist from './unlockTherapist/UnlockTherapist';
import EocDetailsSection, { PencilIcon } from './EocDetailsSection';
import { getEpisodeOfCareDownloads } from 'src/services/apiServices/episodeOfCare/getEpisodeOfCareDownloads';
import { getRealmName } from 'src/routes/AuthContext';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '55%',
  borderRadius: '8px',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const { patients, patientDetails, episodeOfCare, editEpisodeOfCare } = paths;
const EpisodeOfCareViewDetails = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { UPDATE_EPISODE_OF_CARE } = permissions;
  const calenderRef = useRef<HTMLDivElement | null>(null);
  const calenderRef1 = useRef<HTMLDivElement | null>(null);
  const calenderRef2 = useRef<HTMLDivElement | null>(null);
  const episodeOfCareId = state?.episodeOfCareId;
  const episodeOfCareData = useSelector((state: any) => state?.getSingleEpisodeOfCare?.response);
  const closeEpisodeOfCareResponse = useSelector((state: any) => state?.closeEpisodeOfCareReducer);
  const dispatch = useDispatch();
  const screeningData = useSelector((state: any) => state?.getScreeningReducer?.response);
  const screeningResponse = useSelector((state: any) => state?.getScreeningReducer);
  const [providerId] = useCurrentUser(['providerId']);
  const [isDor] = useCheckRole('dor');
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);
  const patientDataLoader = useSelector((state: any) => state.getSinglePatientReducer?.loading);
  const getAllMiscDocsResponse = useSelector(
    (state: any) => state.getAllMiscellaneousDocumentsReducer
  );
  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.currentPermissions
  );
  const getAllSubmittedDocumentResponse = useSelector(
    (state: any) => state.getAllSubmittedDocumentReducer
  );
  const getAllCompletedDoc = useSelector((state: any) => state.getAllCompetedDocReducer);

  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!state.getPatientId) return;
    dispatch(
      getSinglePatient({
        patientId: state.getPatientId,
      })
    );
    dispatch(getScreening({ patientId: state.getPatientId }));
  }, [state]);

  useEffect(() => {
    dispatch(
      getSingleEpisodeOfCare({
        episodeOfCareId,
      })
    );
  }, []);

  useEffect(() => {
    if (
      closeEpisodeOfCareResponse?.isClosed === false &&
      closeEpisodeOfCareResponse?.response === null
    )
      return;
    else if (
      closeEpisodeOfCareResponse?.isClosed === false &&
      closeEpisodeOfCareResponse?.response !== null
    ) {
      setMessage(
        closeEpisodeOfCareResponse?.response?.message || closeEpisodeOfCareResponse?.response?.title
      );
      dispatch(
        getSingleEpisodeOfCare({
          episodeOfCareId,
        })
      );
      setTimeout(() => {
        setMessage('');
        dispatch(resetCloseEpisodeOfCare());
      }, 3500);
    } else {
      setMessage(
        closeEpisodeOfCareResponse?.response?.message || closeEpisodeOfCareResponse?.response?.title
      );
      dispatch(
        getSingleEpisodeOfCare({
          episodeOfCareId,
        })
      );
      setTimeout(() => {
        setMessage('');
        dispatch(resetCloseEpisodeOfCare());
      }, 3000);
    }
  }, [closeEpisodeOfCareResponse]);
  const updateUnlockRes = useSelector((state: any) => state?.updateUnlockTherapistReducer);

  const [openCalender, setOpenCalender] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');

  const handleCloseEOC = () => {
    setAnchorEl(null);
    setOpenCalender(true);
  };

  const handleClickCalender = () => {
    setOpenCalender(false);
  };

  useEffect(() => {
    if (openCalender) {
      const handleClickOutside = (event: any) => {
        if (calenderRef.current && !calenderRef.current.contains(event.target)) {
          // handleClickCalender();
        }
      };

      document.addEventListener('click', handleClickOutside);

      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, [openCalender]);

  const handleChangeDate = (e: any) => {
    const originalDate = new Date(e);
    const day = originalDate.getDate().toString().padStart(2, '0');
    const month = (originalDate.getMonth() + 1).toString().padStart(2, '0');
    const year = originalDate.getFullYear();
    const formattedDate = `${year}-${month}-${day}`;
    setSelectedDate(formattedDate);
    setOpenCalender(false);
    setAnchorEl(null);
    setIsOpen(true);
  };

  const handleOpenEOC = () => {
    setAnchorEl(null);
    dispatch(closeEpisodeOfCare({ episodeOfCareId, status: 'OPENED' }));
  };

  // const [openEocDetails, setOpenEocDetails] = useState(false);

  // const handleCloseEocDetailsDrawer = () => {
  //   setOpenEocDetails(false);
  // };

  // const handleOpenEocDetails = () => {
  //   setOpenEocDetails(true);
  // };
  const [openPrintMode, setOpenPrintMode] = useState(false);

  const handleOpenPrintMode = () => {
    setAnchorEl(null);
    setOpenPrintMode(true);
  };
  const getAssignedFacilities = useSelector((state: any) => state.getFacilityDropDownReducer?.response?.data?.data);
  const getFacilityUuid = localStorage.getItem('facilityId') || '';

  const getFacilityName = () => {
    return getAssignedFacilities?.find((facility: any) => facility?.uuid === getFacilityUuid)?.name ?? ''
  }

  //date 1
  const [openCalender1, setOpenCalender1] = useState(false);
  const [selectedDate1, setSelectedDate1] = useState<any>(new Date());

  //date 2
  const [openCalender2, setOpenCalender2] = useState(false);
  const [selectedDate2, setSelectedDate2] = useState<any>(new Date());

  const activeDiscipline = useSelector((state: any) => state.switchDisciplineReducer);

  const handleClosePrintMode = useCallback(() => {
    setSelectedScreeningDoc([]);
    setIsFilterApply(false);
    setSelectAll(false);
    setMicDocuments([]);
    setDocumentationDoc((prev) => ({
      signaturePending: [],
      completedDoc: [],
    }));
    setSelectedDate1(
      new Date(
        new Date(episodeOfCareData?.startDate).valueOf() +
          new Date(episodeOfCareData?.startDate).getTimezoneOffset() * 60 * 1000
      )
    );
    setSelectedDate2(new Date());
    setOpenPrintMode(false);
    setProgress(0);
  }, []);

  useEffect(() => {
    dispatch(isTherapyPlanningPatient({ patientId: state?.getPatientId }));
  }, []);
  useEffect(() => {
    if (openCalender1) {
      const handleClickOutside = (event: any) => {
        if (calenderRef1.current && !calenderRef1.current.contains(event.target)) {
          // handleClickCalender();
          setOpenCalender1((prev) => !prev);
        }
      };

      document.addEventListener('click', handleClickOutside);

      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, [openCalender1]);

  useEffect(() => {
    if (openCalender2) {
      const handleClickOutside = (event: any) => {
        if (calenderRef2.current && !calenderRef2.current.contains(event.target)) {
          setOpenCalender2((prev) => !prev);
        }
      };

      document.addEventListener('click', handleClickOutside);

      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, [openCalender2]);

  const handleChangeFromDateDate = (e: any, source: any) => {
    const originalDate = new Date(e);

    if (source == 'From') {
      setSelectedDate1(originalDate);
      setOpenCalender1(false);
      return;
    }
    setSelectedDate2(originalDate);
    setOpenCalender2(false);
  };

  const handleFromClickCalender = useCallback(() => {
    setOpenCalender1((prev) => !prev);
    setOpenCalender2(false);
  }, []);

  const handleToClickCalender = useCallback(() => {
    setOpenCalender2((prev) => !prev);
    setOpenCalender1(false);
  }, []);

  const [selectAll, setSelectAll] = useState(false);
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedScreeningDoc([]);
      setDocumentationDoc((prev: any) => ({
        ...prev,
        signaturePending: [],
        completedDoc: [],
      }));
      setMicDocuments([]);
      setSelectAll(false);
      setIsFilterApply(false);
      return;
    }

    setSelectedScreeningDoc(screeningData?.content);
    setDocumentationDoc((prev: any) => ({
      ...prev,
      signaturePending: getAllCompletedDoc?.response?.content || [],
      completedDoc: getAllSubmittedDocumentResponse?.response?.content || [],
    }));
    setMicDocuments(getAllMiscDocsResponse?.response);
    setSelectAll(true);
  };

  const [selectedScreeningDoc, setSelectedScreeningDoc] = useState([]);
  const [MicDocuments, setMicDocuments] = useState([]);
  const [documentationDoc, setDocumentationDoc] = useState({
    signaturePending: [],
    completedDoc: [],
  });

  const [progress, setProgress] = useState(0);

  const onSelectAllClickScreening = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsFilterApply(false);
    if (event.target.checked) {
      setSelectedScreeningDoc(screeningData?.content);
      return;
    }
    setSelectedScreeningDoc([]);
  };

  const onSelectAllClickMicDoc = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsFilterApply(false);
    if (event.target.checked) {
      setMicDocuments(getAllMiscDocsResponse?.response);
      return;
    }
    setMicDocuments([]);
  };

  const downloadFileByUrl = (url: string) => {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = url;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  const handleDownloadSelectedDoc = () => {
    setProgress(0);

    const completedDocs = documentationDoc?.completedDoc;
    const signaturePendingDocs = documentationDoc?.signaturePending;

    const allDocuments = [
      ...selectedScreeningDoc,
      ...MicDocuments,
    ]

    if (completedDocs) {
      allDocuments.push(...completedDocs);
    }

    if (signaturePendingDocs) {
      allDocuments.push(...signaturePendingDocs);
    }

    const uuids = allDocuments?.map((item: any) => {
      return item?.uuid;
    });

    if(!uuids || uuids.length === 0) return;

    getEpisodeOfCareDownloads(getRealmName() || '', episodeOfCareId, activeDiscipline, uuids).then((response) => {
      if(response !== null) {
        downloadFileByUrl(response);
      }
    });
  };

  const getAllDownloadDocs = () => {
    const completedDocs = getAllCompletedDoc?.response?.content;
    const submittedDocs = getAllSubmittedDocumentResponse?.response?.content;
    const miscDocs = getAllMiscDocsResponse?.response;
    const screeningDataDocs = screeningData?.content;
    
    const allDocuments = [];

    if (completedDocs) {
      allDocuments.push(...completedDocs);
    }

    if (submittedDocs) {
      allDocuments.push(...submittedDocs);
    }

    if (miscDocs) {
      allDocuments.push(...miscDocs);
    }

    if (screeningDataDocs) {
      allDocuments.push(...screeningDataDocs);
    }

    return allDocuments;
  }
  const handleDownloadAllDoc = () => {
    setProgress(0);
    const allDocuments = getAllDownloadDocs();

    const uuids = allDocuments?.map((item: any) => {
      return item?.uuid;
    })

    if(!uuids || uuids.length === 0) return;

    getEpisodeOfCareDownloads(getRealmName() || '', episodeOfCareId, activeDiscipline, uuids).then((response) => {
      if(response !== null) {
        downloadFileByUrl(response);
      }
    });
  };

  const selectedDates = useMemo(() => {
    return {
      startDate: selectedDate1,
      endDate: selectedDate2,
    };
  }, [selectedDate1, selectedDate2]);

  useEffect(() => {
    if (!!episodeOfCareData?.startDate) {
      setSelectedDate1(
        new Date(
          new Date(episodeOfCareData?.startDate).valueOf() +
            new Date(episodeOfCareData?.startDate).getTimezoneOffset() * 60 * 1000
        )
      );
    }
  }, [episodeOfCareData]);

  function isDateInRange(date: any, start: any, end: any, source = '') {
    const docDate =
      source === 'pendingSign'
        ? date
        : moment(new Date(convertDateToSelectedTimeZone(date))).format('YYYY-MM-DD');
    return docDate >= start && docDate <= end;
  }
  const [isFilterApply, setIsFilterApply] = useState(false);
  useEffect(() => {
    if (openPrintMode) {
      setMicDocuments([]);
      setDocumentationDoc({
        signaturePending: [],
        completedDoc: [],
      });
      setSelectedScreeningDoc([]);
      setIsFilterApply(false);
    }
  }, [openPrintMode, selectedDates]);

  const applyDateFilter = () => {
    const startDate = moment(selectedDate1).format('YYYY-MM-DD');
    const endDate = moment(selectedDate2).format('YYYY-MM-DD');

    const filteredScreeningDocuments = screeningData?.content?.filter((doc: any) =>
      isDateInRange(doc?.screeningDate, startDate, endDate)
    );

    const filterSignatureDoc = getAllSubmittedDocumentResponse?.response?.content?.filter(
      (doc: any) => isDateInRange(doc?.dateOfService, startDate, endDate, 'pendingSign')
    );
    const filterCompletedDoc = getAllCompletedDoc?.response?.content?.filter((doc: any) =>
      isDateInRange(doc?.dateOfService, startDate, endDate, 'pendingSign')
    );
    const filterMicDocs = getAllMiscDocsResponse?.response?.filter((doc: any) =>
      isDateInRange(doc?.createdOn?.split('T')[0], startDate, endDate, 'pendingSign')
    );
    setMicDocuments(filterMicDocs);
    setDocumentationDoc({
      signaturePending: filterSignatureDoc,
      completedDoc: filterCompletedDoc,
    });

    setSelectedScreeningDoc(filteredScreeningDocuments);
    setIsFilterApply(true);
  };

  const handleCLearAllDoc = () => {
    setSelectedDate1(
      new Date(
        new Date(episodeOfCareData?.startDate).valueOf() +
          new Date(episodeOfCareData?.startDate).getTimezoneOffset() * 60 * 1000
      )
    );
    setSelectedDate2(new Date());
    setMicDocuments([]);
    setDocumentationDoc({
      signaturePending: [],
      completedDoc: [],
    });
    setSelectedScreeningDoc([]);
    setIsFilterApply(false);
  };

  const handleTabSwitch = () => {
    setSelectedDate1(
      new Date(
        new Date(episodeOfCareData?.startDate).valueOf() +
          new Date(episodeOfCareData?.startDate).getTimezoneOffset() * 60 * 1000
      )
    );
    setSelectedDate2(new Date());
    setMicDocuments([]);
    setDocumentationDoc({
      signaturePending: [],
      completedDoc: [],
    });
    setSelectedScreeningDoc([]);
    setIsFilterApply(false);
  };

  const totalNoOfDocumentSelected =
    selectedScreeningDoc?.length +
    MicDocuments.length +
    documentationDoc?.completedDoc?.length +
    documentationDoc?.signaturePending?.length;

  useEffect(() => {
    if (progress == 100) {
      const timeOut = setTimeout(() => {
        setProgress(0);
      }, 800);
      return () => {
        clearInterval(timeOut);
      };
    }
  }, [progress]);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const [openUnlock, setOpenUnlock] = useState(false);
  const onCloseUnlock = () => {
    setOpenUnlock(false);
  };

  const handleOpenUnlock = () => {
    setOpenUnlock(true);
    setAnchorEl(null);
  };

  useEffect(() => {
    if (!updateUnlockRes?.isUpdatedUnlock && updateUnlockRes?.isUpdatedUnlock === null) return;

    if (updateUnlockRes?.isUpdatedUnlock && updateUnlockRes?.isUpdatedUnlock !== null) {
      setOpenUnlock(false);
      setMessage(updateUnlockRes?.response?.message);

      setTimeout(() => {
        setMessage('');
        dispatch(resetUpdateTherapistUnlock());
      }, 3000);
    }
  }, [updateUnlockRes]);

  return (
    <>
      <Stack
        gap="1.5rem"
        sx={{ padding: '0 4rem' }}
      >
        <Button
          sx={{
            justifyContent: 'flex-start',
            color: '#111927',
            width: 'max-content',
            padding: '0px',
          }}
          onClick={() =>
            navigate(`${patients}/${patientDetails}${episodeOfCare}`, {
              state: {
                patientId: state?.patientId,
              },
            })
          }
          startIcon={
            <SvgIcon>
              <ArrowBackIcon sx={{ color: '#6C737F' }} />
            </SvgIcon>
          }
        >
          <Typography variant="subtitle1">Back to Episode Of Care List</Typography>
        </Button>
        <Stack
          alignItems="center"
          justifyContent="space-between"
          flexDirection="row"
        >
          {patientDataLoader ? (
            <Stack>
              <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', gap: 1 }}>
                <Skeleton
                  animation="pulse"
                  variant="circular"
                >
                  <Avatar sx={{ width: 70, height: 70 }} />
                </Skeleton>
                <Box sx={{ width: 100 }}>
                  <Typography
                    width={'100%'}
                    variant="h5"
                  >
                    <Skeleton animation="pulse" />
                  </Typography>
                  <Typography
                    width={'30%'}
                    variant="h5"
                  >
                    <Skeleton animation="pulse" />
                  </Typography>
                </Box>
              </Box>
            </Stack>
          ) : (
            <Stack
              flexDirection="row"
              gap="1rem"
              alignItems="center"
            >
              <Avatar
                src={`data:image/png;base64,${patientData?.profileImage}`}
                sx={{ width: 56, height: 56 }}
              />
              <Typography variant="h4">
                {patientData?.lastName ? patientData?.lastName + ' ' : ''}
                {patientData?.firstName ? patientData?.firstName + '- Episode Of Care' : ''}
              </Typography>
            </Stack>
          )}
          <Stack flexDirection={'row'}>
            {openPrintMode ? (
              <Button
                onClick={handleClosePrintMode}
                startIcon={<CrossIcon />}
                sx={{ color: '#384250' }}
              >
                Close Selection Mode
              </Button>
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                {/* <Button
                  variant="outlined"
                  onClick={handleOpenEocDetails}
                >
                  Episode Details & PoC
                </Button> */}
                <Button
                  variant="contained"
                  endIcon={
                    <SvgIcon>
                      <ExpandMoreIcon />
                    </SvgIcon>
                  }
                  id="basic-button"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  Actions
                </Button>
              </Box>
            )}

            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              sx={{ display: openCalender ? 'none' : 'initial' }}
              onClose={handleCloseMenu}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem
                disabled={
                  selectedScreeningDoc?.length === 0 &&
                  getAllSubmittedDocumentResponse?.response?.content?.length === 0 &&
                  getAllCompletedDoc?.response?.content?.length === 0 &&
                  getAllMiscDocsResponse.response?.length === 0
                }
              >
                <Grid
                  container
                  alignItems={'center'}
                  gap={1}
                  onClick={handleOpenPrintMode}
                >
                  <PrintIcon />
                  <Grid item>Download Files</Grid>
                </Grid>
              </MenuItem>
              {episodeOfCareData?.status === 'CLOSED' ? (
                <MenuItem disabled={closeEpisodeOfCareResponse?.loading}>
                  <Grid
                    container
                    alignItems={'center'}
                    gap={1}
                    onClick={handleOpenEOC}
                  >
                    <EOCOpenIcon />
                    <Grid
                      item
                      sx={{ color: '#B42318' }}
                    >
                      Open Episode of Care
                    </Grid>
                  </Grid>
                </MenuItem>
              ) : (
                <MenuItem disabled={closeEpisodeOfCareResponse?.loading}>
                  <Grid
                    container
                    alignItems={'center'}
                    gap={1}
                    onClick={handleCloseEOC}
                    // ref={calenderRef}
                  >
                    <EOCOpenIcon />
                    <Grid
                      item
                      sx={{ color: '#B42318' }}
                    >
                      Close Episode of Care
                    </Grid>
                  </Grid>
                </MenuItem>
              )}
              {isDor ? (
                <MenuItem>
                  <Grid
                    container
                    alignItems={'center'}
                    gap={1}
                    onClick={handleOpenUnlock}
                  >
                    <LockOpen sx={{ color: '#6C737F' }} />
                    <Grid item>Unlock Document</Grid>
                  </Grid>
                </MenuItem>
              ) : null}
            </Menu>
          </Stack>
        </Stack>

        {openCalender && (
          <CloseEOCCalender
            value={new Date()}
            handleChangeDate={handleChangeDate}
            handleCloseCalendar={handleClickCalender}
            disableDate={
              new Date(
                new Date(episodeOfCareData?.startDate).valueOf() +
                  new Date(episodeOfCareData?.startDate).getTimezoneOffset() * 60 * 1000
              )
            }
          />
        )}

        {/* print Select date */}

        {!!progress && (
          <Stack flexDirection={'row'}>
            <Box sx={{ width: '100%', mr: 1 }}>
              <LinearProgress
                variant="determinate"
                value={progress}
                sx={{ width: '100%', height: '7px', marginTop: '6px' }}
              />
            </Box>
            <Box sx={{ minWidth: 35 }}>
              <Typography
                variant="body2"
                color="text.secondary"
              >{`${Math.round(progress)}%`}</Typography>
            </Box>
          </Stack>
        )}

        {openPrintMode && (
          <Card
            sx={{
              padding: '1.5rem',
              boxShadow: '0px 8px 38px 0px rgba(0, 0, 0, 0.08) !important',
            }}
          >
            <Stack
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="h6"
                mb={3}
                ml={1}
              >
                Select Documents to Download
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Button
                  variant="contained"
                  startIcon={<DownloadIconColor />}
                  onClick={handleDownloadSelectedDoc}
                  disabled={!totalNoOfDocumentSelected}
                >
                  Download Selected{' '}
                  
                  {!!totalNoOfDocumentSelected && `(${totalNoOfDocumentSelected})`}
                </Button>
              </Box>
            </Stack>

            {getAllSubmittedDocumentResponse?.loader ||
              getAllMiscDocsResponse?.loading ||
              (screeningResponse?.loader && (
                <>
                  <Typography
                    width={'170px'}
                    variant="h2"
                  >
                    <Skeleton animation="pulse" />
                  </Typography>
                </>
              ))}

            <Stack>
              <Typography variant="subtitle2">Date Range</Typography>{' '}
            </Stack>
            <Stack
              flexDirection="row"
              justifyContent={'space-between'}
              alignContent={'center'}
            >
              <Stack
                gap={2}
                flexDirection="row"
                alignItems={'center'}
              >
                <Stack ref={calenderRef1}>
                  <Typography
                    sx={{ margin: '10px 0px', color: '#6C737F' }}
                    variant="caption"
                  >
                    From
                  </Typography>{' '}
                  <Button
                    sx={{
                      width: '170px',
                      background: '#fff',
                      borderRadius: '12px',
                      border: '1px solid rgba(17, 25, 39, 0.16)',
                      color: '#384250',
                      '&:hover': {
                        border: '1px solid rgba(17, 25, 39, 0.16)',
                      },
                    }}
                    startIcon={
                      <SvgIcon>
                        <CalenderIcon />
                      </SvgIcon>
                    }
                    variant="outlined"
                    onClick={handleFromClickCalender}
                  >
                    {moment(selectedDate1).format('MMM D, YYYY')}
                  </Button>
                  {openCalender1 ? (
                    <BasicDateRangeCalendar
                      value={selectedDate1}
                      handleChangeDate={(e: any) => handleChangeFromDateDate(e, 'From')}
                      futureDisable={true}
                      minDate={
                        !!episodeOfCareData?.startDate
                          ? new Date(
                              new Date(episodeOfCareData?.startDate).valueOf() +
                                new Date(episodeOfCareData?.startDate).getTimezoneOffset() *
                                  60 *
                                  1000
                            )
                          : null
                      }
                      maxDate={selectedDate2}
                    />
                  ) : null}
                </Stack>
                <Stack sx={{ marginTop: '38px' }}>
                  <ArrowIcon />
                </Stack>

                <Stack ref={calenderRef2}>
                  <Typography
                    sx={{ margin: '10px 0px', color: '#6C737F' }}
                    variant="caption"
                  >
                    To
                  </Typography>{' '}
                  <Button
                    sx={{
                      width: '170px',
                      background: '#fff',
                      borderRadius: '12px',
                      border: '1px solid rgba(17, 25, 39, 0.16)',
                      color: '#384250',
                      '&:hover': {
                        border: '1px solid rgba(17, 25, 39, 0.16)',
                      },
                    }}
                    onClick={handleToClickCalender}
                    startIcon={
                      <SvgIcon>
                        <CalenderIcon />
                      </SvgIcon>
                    }
                    variant="outlined"
                  >
                    {moment(selectedDate2).format('MMM D, YYYY')}
                  </Button>
                  {openCalender2 ? (
                    <BasicDateRangeCalendar
                      value={selectedDate2}
                      handleChangeDate={(e: any) => handleChangeFromDateDate(e, 'To')}
                      futureDisable={true}
                      minDate={selectedDate1}
                    />
                  ) : null}
                </Stack>
                <Stack
                  flexDirection={'row'}
                  sx={{ position: 'relative', bottom: '-21px' }}
                >
                  <Button
                    disabled={isFilterApply}
                    onClick={applyDateFilter}
                    variant="contained"
                  >
                    Apply
                  </Button>
                  <Button
                    onClick={handleCLearAllDoc}
                    sx={{ marginLeft: '10px' }}
                    variant="outlined"
                  >
                    Clear
                  </Button>
                </Stack>
              </Stack>
              <Stack flexDirection={'row'}>
                <Box>
                  <Button
                    variant="text"
                    startIcon={<SaveAlt />}
                    sx={{
                      color: '#384250',
                      height: '40px',
                      position: 'relative',

                      top: '49px',
                    }}
                    disabled={!getAllDownloadDocs() || getAllDownloadDocs().length === 0}
                    onClick={handleDownloadAllDoc}
                  >
                    Download All
                  </Button>
                  <Button
                    variant="text"
                    sx={{
                      color: '#384250',
                      height: '40px',
                      position: 'relative',

                      top: '49px',
                    }}
                    startIcon={
                      totalNoOfDocumentSelected ==
                      getAllSubmittedDocumentResponse?.response?.content?.length +
                        getAllCompletedDoc?.response?.content?.length +
                        screeningData?.content?.length +
                        getAllMiscDocsResponse?.response?.length ? (
                        <CheckBox />
                      ) : (
                        <CheckBoxOutlineBlank />
                      )
                    }
                    onClick={handleSelectAll}
                  >
                    Select All
                  </Button>
                </Box>
              </Stack>
            </Stack>
          </Card>
        )}

        <>
          {true && (
            <>
              <Stack
                flexDirection="row"
                justifyContent="space-between"
                alignItems={'center'}
              >
                <Typography
                  sx={{
                    fontFamily: 'Inter',
                    fontSize: '24px',
                    lineHeight: '36px',
                    fontWeight: '700',
                    letterSpacing: '0.15px',
                  }}
                >
                  Episode Details
                </Typography>
                <Box>
                  <Button
                    startIcon={<PencilIcon />}
                    onClick={() => {
                      dispatch(resetEditEpisodeOfCare());
                      navigate(
                        `${patients}/${patientDetails}${episodeOfCare}${editEpisodeOfCare}`,
                        {
                          state,
                        }
                      );
                    }}
                    disabled={!permissionData?.includes(UPDATE_EPISODE_OF_CARE)}
                  >
                    Edit Details
                  </Button>
                </Box>
              </Stack>
              <Stack>
                <EocDetailsSection />
              </Stack>
              {!episodeOfCareData?.isNonTherapyPatient && (
                // <Card>
                <Documentation
                  documentationDoc={documentationDoc}
                  setDocumentationDoc={setDocumentationDoc}
                  openPrintMode={openPrintMode}
                  setIsFilterApply={setIsFilterApply}
                  handleCLearAllDoc={handleTabSwitch}
                />
                // </Card>
              )}
              {/* <Card> */}
              <MiscellaneousDocuments
                openPrintMode={openPrintMode}
                getAllMiscDocsResponse={getAllMiscDocsResponse}
                MicDocuments={MicDocuments}
                setMicDocuments={setMicDocuments}
                onSelectAllClickMicDoc={onSelectAllClickMicDoc}
                setIsFilterApply={setIsFilterApply}
              />
              {/* </Card> */}
              <Card sx={{ padding: '1.5rem' }}>
                <Card>
                  <Grid
                    container
                    sx={{ padding: '18px 24px 0px 24px', position: 'relative' }}
                    gap="1rem"
                    flexDirection="row"
                    alignItems={'center'}
                  >
                    <Typography variant="h6">Associated Screenings</Typography>
                    <Stack
                      flexDirection="row"
                      sx={{
                        borderRadius: '12px',
                        display: 'flex',
                        border: '1px solid #00000042',
                        color: '#111927',
                        padding: '3px 10px',
                      }}
                    >
                      <Typography variant="subtitle2">
                        {!screeningData
                          ? '0 Screening'
                          : `${screeningData?.content?.length} Screenings`}
                      </Typography>
                    </Stack>
                  </Grid>
                  <ScreeningsTable
                    screeningData={screeningData?.content}
                    isForEpisodeOfCare={true}
                    openPrintMode={openPrintMode}
                    onSelectAllClickScreening={onSelectAllClickScreening}
                    selectedScreeningDoc={selectedScreeningDoc}
                    setSelectedScreeningDoc={setSelectedScreeningDoc}
                    setIsFilterApply={setIsFilterApply}
                  />
                </Card>
              </Card>
            </>
          )}
        </>
      </Stack>
      <Drawer
        anchor="right"
        onClose={onCloseUnlock}
        open={openUnlock}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: 550,
          },
        }}
      >
        <UnlockTherapist onCloseUnlock={onCloseUnlock} />
      </Drawer>
      {/* <Drawer
        anchor="right"
        onClose={handleCloseEocDetailsDrawer}
        open={openEocDetails}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: 444,
          },
        }}
      >
        <EocDetailsDrawer handleCloseEocDetailsDrawer={handleCloseEocDetailsDrawer} />
      </Drawer> */}

      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack
            flexDirection="row"
            gap="1rem"
            alignItems={'center'}
          >
            <img
              src={discardIcon}
              width="40px"
              height="40px"
              alt=""
            />
            <Stack gap=".75rem">
              <Typography
                id="modal-modal-title"
                variant="h5"
              >
                {`Close Episode of Care`}
              </Typography>
              <Typography
                id="modal-modal-title"
                variant="caption2Text"
              >
                {`Are you sure you want to close this Episode of Care? This cannot be undone.`}
              </Typography>
            </Stack>
          </Stack>
          <Stack
            flexDirection="row"
            gap="1rem"
            justifyContent="flex-end"
            sx={{ marginTop: '1rem' }}
          >
            <Button
              onClick={() => setIsOpen(false)}
              color="inherit"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color={'error'}
              onClick={() => {
                dispatch(
                  closeEpisodeOfCare({ episodeOfCareId, endDate: selectedDate, status: 'CLOSED' })
                );
                setIsOpen(false);
              }}
            >
              {'Close Episode'}
            </Button>
          </Stack>
        </Box>
      </Modal>
      {message !== '' &&
        (closeEpisodeOfCareResponse?.response !== null || updateUnlockRes?.response !== null) && (
          <SimpleSnackbar
            message={message}
            isError={!closeEpisodeOfCareResponse?.isClosed && !updateUnlockRes?.isUpdatedUnlock}
          />
        )}
    </>
  );
};

export default EpisodeOfCareViewDetails;
